const getDataDogContext = () => {
    var _a, _b, _c;
    return {
        microFrontendVersions: (_a = window === null || window === void 0 ? void 0 : window.__THRIVE__) !== null && _a !== void 0 ? _a : [],
        thrivePlatform: (_c = (_b = window === null || window === void 0 ? void 0 : window.getThriveClient) === null || _b === void 0 ? void 0 : _b.call(window)) !== null && _c !== void 0 ? _c : 'unknown'
    };
};
export const captureError = (error, boundaryName, boundaryType, packageName, packageVersion, packageOwner, context = {}) => {
    var _a, _b;
    const reportedError = typeof error === 'string' ? new Error(error) : error;
    try {
        (_a = window.DD_RUM) === null || _a === void 0 ? void 0 : _a.addError(reportedError, Object.assign(Object.assign({ boundaryName,
            boundaryType,
            packageName,
            packageVersion,
            packageOwner }, getDataDogContext()), context));
    }
    catch (err) {
        console.error('DataDog Not Present in Application');
    }
    try {
        (_b = window.DD_LOGS) === null || _b === void 0 ? void 0 : _b.logger.error(reportedError.message, Object.assign(Object.assign({ boundaryName,
            boundaryType,
            packageName,
            packageVersion,
            packageOwner }, getDataDogContext()), context), reportedError);
    }
    catch (err) {
        console.error('DataDog Logger Not present');
    }
};
//# sourceMappingURL=datadog.js.map